import "./notificationsDrawer.css";

import React, { useContext, useEffect, useState } from 'react';
import { Drawer, List, Tooltip, Skeleton } from "antd";
import { EyeOutlined, EyeInvisibleOutlined, LoadingOutlined } from '@ant-design/icons';
import ReactTimeAgo from 'react-time-ago';
import _ from "lodash";
import InfiniteScroll from 'react-infinite-scroll-component';
import NotificationsContext from './../context/notificationsContext';
import { getNotifications, readNotification } from '../services/notificationsService';
import { parseUTC } from './../utils/date';

const TAKE = 10;

function NotificationsDrawer({ visible, onClose }) {
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const notificationsContext = useContext(NotificationsContext);

    useEffect(() => {
        async function process(){
            setLoading(true);
            const { data } = await getNotifications(TAKE, 0);
            notificationsContext.setNotifications(data.notifications);
            setLoading(false);
        }

        process();
    }, []);

    const handleRead = async (id, isRead) => {
        const tmp = notificationsContext.notifications;
        const not = tmp.filter(n => n.id === id)[0];
        not.loading = true;
    
        notificationsContext.setNotifications([...tmp]);
    
        const { data } = await readNotification(id, isRead);
        
        not.loading = false;
        not.isRead = data.isRead;
        notificationsContext.setNotifications([...tmp]);
    };

    const loadMore = async () => {
        const { data } = await getNotifications(TAKE, notificationsContext.notifications.length);
        notificationsContext.setNotifications([...notificationsContext.notifications, ...data.notifications]);

        if(data && data.notifications.length === 0) setHasMore(false);
    };

    return (<NotificationsContext.Consumer>
        {({ notifications }) => {
            // Notifications sorted descending by date, newest to oldest
            var data =  _.orderBy(notifications, d => parseUTC(d.date), "desc");

            return <Drawer className="drawer-notifications" title="Notificaciones" width="500px" placement="right" onClose={onClose} visible={visible}>
                <div id="scrollableDiv" style={{ 
                    height: `${window.innerHeight - 100}px`,
                    overflow: "auto"
                }}>
                    <InfiniteScroll
                        dataLength={data.length}
                        next={loadMore}
                        hasMore={hasMore}
                        loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                        scrollableTarget="scrollableDiv"
                    >
                        <List loading={loading} itemLayout="horizontal" dataSource={data}
                            renderItem={item => <List.Item className={item.isRead ? "" : "notification-unread"}>
                                <List.Item.Meta
                                title={item.message}
                                description={<p>
                                    <ReactTimeAgo date={parseUTC(item.date)} />
                                    <Tooltip className="eye-tooltip" title={`Marcar como ${item.isRead ? "no " : ""}leído`}>
                                        <span onClick={() => handleRead(item.id, !item.isRead)}>{item.loading ? <LoadingOutlined /> : item.isRead ? <EyeInvisibleOutlined /> : <EyeOutlined />}</span>
                                    </Tooltip>
                                </p>}
                                />
                            </List.Item>}
                        />
                    </InfiniteScroll>
                </div>
            </Drawer>
        }}
    </NotificationsContext.Consumer>);
}

export default NotificationsDrawer;


// WEBPACK FOOTER //
// ./src/components/NotificationsDrawer.jsx